import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';
import React from 'react';
import SpecialistInfoCard from '../Components/SpecialistInfoCard';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import PatientRegistrationForm from '../Components/PatientRegistrationForm/PatientRegistrationForm';
import { useUserState } from '@/components/context/UserContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import PaymentSummaryCard from '../Components/ConsultationDetailsForm/PaymentSummaryCard';

export default function PatientInfoStep({ goNext, goPrev }) {
  const history = useHistory();
  const userState = useUserState();
  const isLoggedIn = !!userState?.isLoggedIn;

  return (
    <div className="flex flex-col sm:flex-row sm:gap-4">
      <div className="sm:w-2/3">
        <Card>
          <CardHeader>
            {/* Top row: back+heading (left), login button (right on sm) */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => goPrev()}
                  className="flex items-center gap-1 hover:opacity-80 focus:outline-none"
                >
                  <ChevronLeft className="w-8 h-8 text-secondary" />
                  <Heading variant="2">Registracija paslaugai</Heading>
                </button>
              </div>

              {/* Desktop login button (only if not logged in) */}
              {!isLoggedIn && (
                <div className="hidden sm:block">
                  <Button
                    variant="light"
                    onClick={() => history.push('/selfservice')}
                  >
                    Prisijungti
                  </Button>
                </div>
              )}
            </div>

            {/* Subheading */}
            <Label variant="subheading">
              Prisijungus prie paskyros, duomenis užpildysime automatiškai.
            </Label>

            {/* Mobile login button (only if not logged in) */}
            {!isLoggedIn && (
              <div className="sm:hidden">
                <Button
                  variant="light"
                  onClick={() => history.push('/selfservice')}
                >
                  Prisijungti
                </Button>
              </div>
            )}
          </CardHeader>

          <CardContent>
            {/* onValid fires only after successful RHF/Zod validation */}
            <PatientRegistrationForm onValid={goNext} />
          </CardContent>

          <CardFooter>
            {/* This submits the form above by id and only proceeds via onValid */}
            <Button
              type="submit"
              form="patient-form-id"
              className="hidden sm:block sm:w-full"
            >
              Pereiti prie paslaugos informacijos
            </Button>
          </CardFooter>
        </Card>
      </div>

      <div className="sm:w-1/3 mt-2 sm:mt-0">
        <div className="flex flex-col gap-4">
          <SpecialistInfoCard />
          <PaymentSummaryCard />
        </div>
      </div>

      <div className="mt-6 sm:hidden">
        <Button type="submit" form="patient-form-id">
          Pereiti prie paslaugos informacijos
        </Button>
      </div>
    </div>
  );
}
